export enum ModuleTypeEnum {
  ATTENDANCE = 'attendance',
  EVENTLIMIT = 'eventlimit',
  DAILYLIMIT = 'dailylimit',
}
